module.exports = __webpack_public_path__ + "img/selected1-min.f1e189c1.png";